import React, { useRef } from 'react';

// This is a variant of input select used for filtering the site
export default function InputSelectFilter(props) {
  const selectRef = useRef(null);
  return (
  <div className={`input-select-filter curp posr h48 bgc-white h-auto@sm ${ props.className || '' }`}>
    <span
      className="posa r16 center-vert z0"
      onClick={() => selectRef.current.click()}
    >
      &#9662;
    </span>
    <select
      ref={selectRef}
      {...props}
      className="posr bdn w100% h100% p8 pr32 pl16 p16@sm pr32@sm bgc-transparent c-black z1 fw500 ff-gr"
      {...(props.onChange ? { onChange : () => props.onChange(selectRef.current) } : {})}
    >
      { props.children }
    </select>
  </div>
  )
}
